import { ref, watch } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { getSiteConfig } from '@shared/api/systemData.api'

export function useSiteConfigLoader(siteConfigName) {
  const siteConfig = ref(null)

  const { data, isLoading, error } = useQuery({
    queryKey: ['siteConfig', siteConfigName],
    queryFn: async () => {
      const response = await getSiteConfig(siteConfigName)
      return response
    },
    enabled: !!siteConfigName,
    retry: 3,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })

  watch(data, (newData) => {
    siteConfig.value = newData || null
  }, { immediate: true })

  watch(error, (newError) => {
    if (newError) {
      console.error('useSiteConfigLoader error:', newError)
    }
  })

  return {
    siteConfig,
    isLoading,
    error,
  }
}
